<template>
  <div class="container">
    <div class="title">新建案例</div>
    <div class="wrap">
      <el-row>
        <el-col
          :lg="16"
          :md="20"
          :sm="24"
          :xs="24">
          <el-form
            :model="form"
            :rules="rules"
            status-icon
            ref="form"
            label-width="100px"
            @submit.native.prevent>
            <el-form-item label="案例名" prop="title">
              <el-input size="medium" v-model="form.title" placeholder="请填项目名"></el-input>
            </el-form-item>
            <el-form-item label="主页显示" prop="summary">
              <el-switch size="medium" v-model="form.display"></el-switch>
            </el-form-item>
            <el-form-item label="简介" prop="summary">
              <el-input size="medium" type="textarea" autosize v-model="form.summary" placeholder="请填写简介"></el-input>
            </el-form-item>
            <el-form-item label="标签" prop="tag">
              <tags ref="tags" v-model="tagSelection"/>
            </el-form-item>
            <el-form-item label="地址" prop="url">
              <el-input size="medium" v-model="form.url" placeholder="请填写案例地址URL"></el-input>
            </el-form-item>
            <el-form-item label="封面" prop="image">
              <uploader ref="uploader" v-model="form.image"/>
              <el-input size="medium" v-model="form.image" placeholder="封面地址"></el-input>
            </el-form-item>
            <el-form-item label="Banner" prop="banner">
              <uploader ref="bannerUploader" v-model="form.banner"/>
              <el-input size="medium" v-model="form.banner" placeholder="Banner地址(可空，此时为默认banner)"></el-input>
            </el-form-item>
            <el-form-item label="正文" prop="content">
              <tinymce-editor ref="tinymce" v-model="form.content" />
            </el-form-item>
            <!-- <el-form-item label="描述" prop="summary">
              <el-input
                size="medium"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 8}"
                placeholder="请输入简介"
                v-model="form.summary">
              </el-input>
            </el-form-item> -->

            <el-form-item class="submit">
              <el-button type="primary" @click="submitForm('form')">保 存</el-button>
              <el-button @click="resetForm('form')">重 置</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
import showcase from '../models/showcase'
import Uploader from '../../Common/components/file/uploader'
import TinymceEditor from '../../Common/components/tinymce-editor'
import Tags from './Tags'
import { CheckUrl } from '../../Common/validator'

export default {
  components: {
    Uploader,
    TinymceEditor,
    Tags,
  },
  data() {
    const validateTitle = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入项目名'))
      }
      callback()
    }

    const validateUrl = (rule, value, callback) => {
      if (!CheckUrl(value)) {
        callback(new Error('请输入正确的项目地址'))
      }
      callback()
    }

    const validateImage = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请添加案例封面'))
      }
      callback()
    }
    return {
      tagSelection: [],
      form: {
        title: '',
        tags: '',
        summary: '',
        content: '',
        image: '',
        qr_image: '',
      },
      rules: {
        title: [
          { validator: validateTitle, trigger: 'blur', required: true },
        ],
        url: [
          { validator: validateUrl, trigger: 'blur', required: true },
        ],
        image: [
          { validator: validateImage, trigger: 'blur', required: true },
        ],
      },
    }
  },
  methods: {
    async submitForm(formName) {
      this.form.tags = this.tagSelection.join(',')
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            const res = await showcase.addData(this.form)
            if (res.error_code === 0) {
              this.$message.success(`${res.msg}`)
              this.resetForm(formName)
            }
          } catch (error) {
            console.log(error)
          }
        } else {
          console.log('error submit!!')
          this.$message.error('请填写正确的信息')
          return false
        }
      })
    },
    onUploded(url) {
      this.form.image = url
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$refs.uploader.reset()
      this.$refs.bannerUploader.reset()
      this.refs.tinymce.clear()

      this.tagSelection = []
      this.$refs.tags.updateTags()
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  .title {
    height: 59px;
    line-height: 59px;
    color: $parent-title-color;
    font-size: 16px;
    font-weight: 500;
    text-indent: 40px;
    border-bottom: 1px solid #dae1ec;
  }

  .wrap {
    padding: 20px;
  }

  .submit {
    float: left;
  }
}
</style>
